import React from 'react';
import { useUIStore } from '../../store/uiStore'; // Corrected import path
// No longer need useChatStore here for setChatViewMode
// import { useChatStore } from '../../store/chatStore'; 
import styles from './ChatBubble.module.css'; // Import the CSS module
import { ChatBubbleIcon } from '../common/Icons'; // Import the new icon
import useAuthStore from '../../store/authStore'; // Import authStore
import { initializeChatData } from '../../App'; // Import the initialize function

// No props needed for this component currently
// interface ChatBubbleProps {
//   // Props if any, e.g., initial text, icon
// }

const ChatBubble: React.FC = () => { // Removed ChatBubbleProps
  // Get the specific action from the new uiStore
  const openChatToSidebar = useUIStore((state) => state.openChatToSidebar);
  const setIsInitializingChat = useUIStore((state) => state.setIsInitializingChat);
  const isLoadingInitialData = useAuthStore((state) => state.isLoadingInitialData); // Get loading state to prevent double clicks
  const initialDataLoaded = useAuthStore((state) => !!state.jwt); // To check if data is already loaded

  // Get actions from authStore to pass to initializeChatData
  const setLoadingInitialData = useAuthStore((state) => state.setLoadingInitialData);
  const setInitialData = useAuthStore((state) => state.setInitialData);
  const setInitialDataError = useAuthStore((state) => state.setInitialDataError);

  const handleClick = async () => {
    if (isLoadingInitialData) { // Only prevent if actively loading
      console.log('Chat bubble clicked. Initial data is already loading.');
      return;
    }

    if (initialDataLoaded) {
      // If data is already loaded, just open the sidebar
      console.log('Chat bubble clicked. Initial data already loaded. Opening to sidebar.');
      openChatToSidebar();
      return;
    }

    console.log('Chat bubble clicked. Setting initializing state and opening sidebar...');
    setIsInitializingChat(true); // Set global initializing flag from uiStore
    openChatToSidebar(); // Open sidebar immediately so loading indicator inside it can show

    console.log('Chat bubble: Now attempting to initialize chat data...');
    // setLoadingInitialData(true) is called inside initializeChatData
    await initializeChatData(
      setLoadingInitialData,
      setInitialData,
      setInitialDataError
    );
    
    // setLoadingInitialData(false) is called inside initializeChatData finally block
    console.log('Chat bubble: Chat data initialization complete. Clearing initializing flag.');
    setIsInitializingChat(false); // Clear global initializing flag
    // openChatToSidebar() was already called
  };

  return (
    <button
      onClick={handleClick}
      className={styles.chatBubble} // Apply the CSS module class
      aria-label="Deschide widgetul de chat"
      title="Deschide widgetul de chat" // Added title for better tooltip on hover
    >
      <ChatBubbleIcon className={styles.chatBubbleIcon} title="Pictogramă chat" /> {/* Replaced span with icon component */}
      <span className={styles.chatBubbleText}>Ce provocări de marketing încerci să rezolvi astăzi?</span>
    </button>
  );
};

export default ChatBubble; 